import { useRouter } from "next/router";

function useParams() {
  const { query } = useRouter();

  return query;
}

function useParam(key: string) {
  const { [key]: param } = useParams();

  if (typeof param !== "string") throw new Error(`missing ${key}`);

  return param;
}

export { useParams, useParam };
